import {
  CLEAR_ADMIN_PAGINATION_STATE,
  GET_ADMIN_PAGINATION_STATE,
  SET_ACCOUNTS_PAGINATION_STATE,
  SET_USERS_PAGINATION_STATE,
  SET_EMAILTEMPLATES_PAGINATION_STATE,
} from "./AdminPaginationRowType";

const initialState = {
  accountsState: {},
  usersState: {},
  emailTemplatesState: {},
};

const AdminPaginationRowReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADMIN_PAGINATION_STATE:
      return {
        ...state,
      };
    case SET_ACCOUNTS_PAGINATION_STATE:
      return {
        ...state,
        accountsState: action.payload.accountsState,
      };
    case SET_USERS_PAGINATION_STATE:
      return {
        ...state,
        usersState: action.payload.usersState,
      };
    case SET_EMAILTEMPLATES_PAGINATION_STATE:
      return {
        ...state,
        emailTemplatesState: action.payload.emailTemplatesState,
      };

    case CLEAR_ADMIN_PAGINATION_STATE:
      return {
        ...state,
        accountsState: null,
        usersState: null,
        emailTemplatesState: null,
      };
    default:
      return state;
  }
};

export default AdminPaginationRowReducer;
